import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M6 3h2v1h2V1H0v3h2V3h2v10H2v2h5.999v-2H6z\"></path><path d=\"M8 6v3h2V8h1v5h-1v2h4v-2h-1V8h1v1h2V6z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }